/* Land Classics — "Mi Land Rover": selector de vehículo y compatibilidad */
(function () {
  var DATA = {
    rrc: { name: 'Range Rover Classic', years: '1970–1996', col: 'range-rover-classic', model: 'lc-rrc',
      engines: [['v-rrc-v8', 'V8 gasolina (3.5 / 3.9 / 4.2)'], ['v-rrc-200tdi', '200Tdi'], ['v-rrc-300tdi', '300Tdi'], ['v-rrc-vm', 'VM diésel']] },
    d1: { name: 'Discovery I', years: '1989–1998', col: 'discovery-1', model: 'lc-d1',
      engines: [['v-d1-v8', 'V8 gasolina (3.5 / 3.9)'], ['v-d1-mpi', '2.0 Mpi gasolina'], ['v-d1-200tdi', '200Tdi'], ['v-d1-300tdi', '300Tdi']] },
    d2: { name: 'Discovery II', years: '1998–2004', col: 'discovery-2', model: 'lc-d2',
      engines: [['v-d2-td5', 'Td5'], ['v-d2-v8', 'V8 gasolina (4.0)']] },
    def: { name: 'Defender', years: '1983–2016', col: 'defender', model: 'lc-defender',
      engines: [['v-def-25', '2.5 D / TD / gasolina'], ['v-def-200tdi', '200Tdi'], ['v-def-300tdi', '300Tdi'], ['v-def-td5', 'Td5'], ['v-def-puma', 'Puma 2.4 / 2.2 TDCi'], ['v-def-v8', 'V8 gasolina']] }
  };
  var lang = (document.documentElement.lang || 'es').slice(0, 2);
  var T = {
    es: { model: 'Modelo', engine: 'Motor', pick: 'Elige modelo', pickE: 'Elige motor', go: 'Ver piezas', mine: 'Mi Land Rover', change: 'Cambiar', clear: 'Quitar',
      ok: 'Compatible con tu', no: 'No figura como compatible con tu', check: 'Indica tu vehículo para comprobar la compatibilidad', choose: 'Elegir vehículo' },
    en: { model: 'Model', engine: 'Engine', pick: 'Choose model', pickE: 'Choose engine', go: 'Show parts', mine: 'My Land Rover', change: 'Change', clear: 'Remove',
      ok: 'Fits your', no: 'Not listed as fitting your', check: 'Select your vehicle to check fitment', choose: 'Choose vehicle' },
    fr: { model: 'Modèle', engine: 'Moteur', pick: 'Choisir le modèle', pickE: 'Choisir le moteur', go: 'Voir les pièces', mine: 'Mon Land Rover', change: 'Modifier', clear: 'Retirer',
      ok: 'Compatible avec votre', no: 'Non indiqué comme compatible avec votre', check: 'Indiquez votre véhicule pour vérifier la compatibilité', choose: 'Choisir le véhicule' }
  }[lang] || null;
  if (!T) T = { model: 'Modelo', engine: 'Motor', pick: 'Elige modelo', pickE: 'Elige motor', go: 'Ver piezas', mine: 'Mi Land Rover', change: 'Cambiar', clear: 'Quitar', ok: 'Compatible con tu', no: 'No figura como compatible con tu', check: 'Indica tu vehículo para comprobar la compatibilidad', choose: 'Elegir vehículo' };

  var KEY = 'lc_vehiculo';
  function load() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function save(v) { try { v ? localStorage.setItem(KEY, JSON.stringify(v)) : localStorage.removeItem(KEY); } catch (e) {} }
  function label(v) {
    if (!v || !DATA[v.m]) return '';
    var d = DATA[v.m], e = d.engines.filter(function (x) { return x[0] === v.e; })[0];
    return d.name + (e ? ' · ' + e[1] : '');
  }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function urlFor(v) { var d = DATA[v.m]; return root() + 'collections/' + d.col + (v.e ? '/' + v.e : ''); }

  function fillEngines(sel, m, current) {
    sel.innerHTML = '<option value="">' + T.pickE + '</option>';
    if (!DATA[m]) { sel.disabled = true; return; }
    DATA[m].engines.forEach(function (e) {
      var o = document.createElement('option'); o.value = e[0]; o.textContent = e[1];
      if (e[0] === current) o.selected = true; sel.appendChild(o);
    });
    sel.disabled = false;
  }

  function initSelector(box) {
    var sm = box.querySelector('[name=lc_m]'), se = box.querySelector('[name=lc_e]'), btn = box.querySelector('[data-lc-go]');
    if (!sm || !se) return;
    sm.innerHTML = '<option value="">' + T.pick + '</option>';
    Object.keys(DATA).forEach(function (k) {
      var o = document.createElement('option'); o.value = k; o.textContent = DATA[k].name + ' (' + DATA[k].years + ')'; sm.appendChild(o);
    });
    var v = load();
    if (v && DATA[v.m]) { sm.value = v.m; fillEngines(se, v.m, v.e); } else { fillEngines(se, '', ''); }
    sm.onchange = function () { fillEngines(se, sm.value, ''); };
    if (btn) btn.onclick = function (ev) {
      ev.preventDefault();
      if (!sm.value) { sm.focus(); return; }
      var nv = { m: sm.value, e: se.value || '' };
      save(nv);
      window.location.href = urlFor(nv);
    };
  }

  function initMyCar() {
    var v = load();
    document.querySelectorAll('[data-lc-mycar-label]').forEach(function (el) {
      el.textContent = v ? label(v) : T.choose;
    });
    document.querySelectorAll('[data-lc-mycar-link]').forEach(function (a) {
      if (v) { a.href = urlFor(v); a.hidden = false; } else { a.hidden = true; }
    });
    document.querySelectorAll('[data-lc-clear]').forEach(function (b) {
      b.hidden = !v;
      b.onclick = function (e) { e.preventDefault(); save(null); initMyCar(); document.querySelectorAll('[data-lc-selector]').forEach(initSelector); initCompat(); };
    });
  }

  // ¿Vale para el vehículo? true / false / null (la ficha no indica vehículo)
  function fitsTags(v, tags) {
    if (!v || !DATA[v.m]) return null;
    var d = DATA[v.m];
    var known = tags.some(function (t) { return /^v-/.test(t) || t === 'lc-rrc' || t === 'lc-d1' || t === 'lc-d2' || t === 'lc-defender'; });
    if (!known) return null;
    if (!v.e) return tags.indexOf(d.model) > -1;
    if (tags.indexOf(v.e) > -1) return true;
    var pre = v.e.replace(/^(v-[a-z0-9]+-).*$/, '$1');
    var anyEngine = tags.some(function (t) { return t.indexOf(pre) === 0; });
    return !anyEngine && tags.indexOf(d.model) > -1;
  }

  function initCompat() {
    var v = load();
    document.querySelectorAll('[data-lc-compat]').forEach(function (el) {
      var tags = (el.getAttribute('data-tags') || '').split(',').map(function (s) { return s.trim(); });
      var st = el.querySelector('[data-lc-compat-status]');
      if (!st) return;
      el.classList.remove('is-ok', 'is-no', 'is-unknown');
      if (!v || !DATA[v.m]) { el.classList.add('is-unknown'); st.textContent = T.check; return; }
      var d = DATA[v.m];
      var fits = fitsTags(v, tags) === true;
      el.classList.add(fits ? 'is-ok' : 'is-no');
      st.textContent = (fits ? '✓ ' + T.ok + ' ' : '✕ ' + T.no + ' ') + label(v);
    });
  }

  function fromUrl() {
    var m = window.location.pathname.match(/\/collections\/([^\/]+)\/(v-[a-z0-9-]+)/);
    if (!m) return;
    Object.keys(DATA).forEach(function (k) {
      if (DATA[k].col === m[1] && DATA[k].engines.some(function (e) { return e[0] === m[2]; })) save({ m: k, e: m[2] });
    });
  }

  function init() {
    fromUrl();
    document.querySelectorAll('[data-lc-selector]').forEach(initSelector);
    document.querySelectorAll('[data-lc-t]').forEach(function (el) { var k = el.getAttribute('data-lc-t'); if (T[k]) el.textContent = T[k]; });
    initMyCar();
    initCompat();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* Compra rápida en tarjetas (cantidad + añadir) */
  function cartCount(n) {
    document.querySelectorAll('.lc-cart').forEach(function (a) { a.textContent = a.textContent.replace(/\d+\s*$/, n); });
  }
  document.addEventListener('click', function (e) {
    var st = e.target.closest && e.target.closest('[data-lc-step]');
    if (st) {
      e.preventDefault(); e.stopPropagation();
      var n = st.parentNode.querySelector('input'); var v = (parseInt(n.value, 10) || 1) + parseInt(st.getAttribute('data-lc-step'), 10);
      n.value = Math.max(1, v); return;
    }
    if (e.target.closest && e.target.closest('[data-lc-buy]')) { e.stopPropagation(); if (!e.target.closest('.lc-buy__add')) e.preventDefault(); }
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-lc-buy]');
    if (!f) return;
    e.preventDefault(); e.stopPropagation();
    var b = f.querySelector('.lc-buy__add'); var txt = b.textContent; b.disabled = true;
    fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
      .then(function (r) { if (!r.ok) throw r; return fetch(root() + 'cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartCount(c.item_count); b.textContent = b.getAttribute('data-added') || '✓'; f.classList.add('is-added');
        setTimeout(function () { b.textContent = txt; b.disabled = false; f.classList.remove('is-added'); }, 2200); })
      .catch(function () { f.submit(); });
  }, true);

  /* Relacionados en la ficha */
  function initRelated() {
    var box = document.querySelector('[data-lc-related]'); if (!box) return;
    var grid = box.querySelector('[data-lc-related-grid]');
    var models = (box.getAttribute('data-models') || '').split(',').filter(Boolean);
    var part = box.getAttribute('data-part'), sys = box.getAttribute('data-sys'), ex = box.getAttribute('data-exclude');
    var v = load(), m = models[0] || '';
    if (v && DATA[v.m] && models.indexOf(DATA[v.m].model) > -1) m = DATA[v.m].model;
    var urls = [];
    function add(tags) { tags = tags.filter(Boolean); if (tags.length) urls.push(root() + 'collections/all/' + tags.join('+')); }
    if (part) add([m, part]);
    if (sys) add([m, sys]);
    if (part) add([part]);
    var seen = {}, count = 0, MAX = 8;
    seen[ex] = 1;
    function next() {
      if (count >= MAX || !urls.length) { if (count) box.hidden = false; return; }
      var u = urls.shift();
      fetch(u + '?section_id=lc-related-items&sort_by=best-selling').then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html;
        d.querySelectorAll('.lc-rel__item').forEach(function (li) {
          var h = li.getAttribute('data-handle'); if (count >= MAX || seen[h]) return;
          seen[h] = 1; count++; grid.appendChild(li);
        });
        next();
      }).catch(next);
    }
    next();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initRelated); else initRelated();
  /* Buscador:
     - Por referencia: primero las variantes de la referencia buscada, AG PARTS delante y luego por precio.
     - Con «Mi Land Rover» elegido: primero lo que vale para su vehículo, luego lo que no indica vehículo y al final lo que no vale (atenuado). */
  function initSearchSort() {
    if (!/\/search\/?$/.test(location.pathname)) return;
    var p = new URLSearchParams(location.search), sb = p.get('sort_by');
    var relevance = !sb || sb === 'relevance';
    var q = (p.get('q') || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    var refMode = relevance && q.length >= 4 && /\d/.test(q);
    var v = load(); if (v && !DATA[v.m]) v = null;
    if (!refMode && !v) return;
    var FT = { es: ['Para tu', 'No figura para tu', 'Mostrando primero las piezas para tu', 'Quitar vehículo', 'Ver solo las de mi', 'Mostrando solo piezas para tu', 'Ver todos los resultados'],
               en: ['Fits your', 'Not listed for your', 'Showing parts for your', 'Remove vehicle', 'Only show parts for my', 'Showing only parts for your', 'Show all results'],
               fr: ['Pour votre', 'Non indiqué pour votre', 'Priorité aux pièces pour votre', 'Retirer le véhicule', 'Uniquement pour mon', 'Uniquement les pièces pour votre', 'Voir tous les résultats'] }[lang] || null;
    if (!FT) FT = ['Para tu', 'No figura para tu', 'Mostrando primero las piezas para tu', 'Quitar vehículo', 'Ver solo las de mi', 'Mostrando solo piezas para tu', 'Ver todos los resultados'];
    var vtag = v ? (v.e || DATA[v.m].model) : '';
    var only = !!vtag && p.getAll('filter.p.tag').indexOf(vtag) > -1;
    function withTag(on) {
      var u = new URL(location.href), keep = u.searchParams.getAll('filter.p.tag').filter(function (t) { return t !== vtag; });
      u.searchParams.delete('filter.p.tag'); keep.forEach(function (t) { u.searchParams.append('filter.p.tag', t); });
      if (on) u.searchParams.append('filter.p.tag', vtag);
      u.searchParams.delete('page');
      return u.pathname + u.search;
    }
    var busy = false;
    function run() {
      if (busy) return; busy = true;
      var forms = document.querySelectorAll('form[data-lc-buy][data-sku]');
      var items = [], parent = null;
      forms.forEach(function (f, i) {
        var li = f.closest('li') || f.closest('.product-grid__item'); if (!li || !li.parentNode) return;
        if (!parent) parent = li.parentNode; if (li.parentNode !== parent) return;
        var sku = (f.getAttribute('data-sku') || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
        var hit = refMode && (sku.indexOf(q) === 0 || (sku.length >= 4 && q.indexOf(sku) === 0));
        var ag = /AG$/.test(sku) || /\bAG PARTS\b/i.test(f.getAttribute('data-vendor') || '');
        var fit = null;
        if (v) {
          var tags = (f.getAttribute('data-veh') || '').split(',').filter(Boolean);
          fit = fitsTags(v, tags);
          var mk = li.querySelector('[data-lc-fit]');
          if (mk && !mk.getAttribute('data-done')) {
            mk.setAttribute('data-done', '1');
            if (fit !== null) { mk.hidden = false; mk.className = 'lc-fit ' + (fit ? 'is-ok' : 'is-no'); mk.textContent = (fit ? '✓ ' + FT[0] : '✕ ' + FT[1]) + ' ' + label(v); }
          }
          li.classList.toggle('lc-nofit', fit === false);
        }
        items.push({ li: li, i: i, hit: hit, ag: ag, price: parseInt(f.getAttribute('data-price'), 10) || 0, fr: fit === true ? 0 : fit === null ? 1 : 2 });
      });
      if (v && parent && !document.querySelector('.lc-sveh')) {
        var b = document.createElement('div'); b.className = 'lc-sveh';
        b.appendChild(document.createTextNode((only ? FT[5] : FT[2]) + ' ' + label(v) + '.'));
        var a = document.createElement('a'); a.className = 'lc-sveh__go';
        a.href = withTag(!only); a.textContent = only ? FT[6] : FT[4] + ' ' + label(v);
        b.appendChild(a);
        var x = document.createElement('button'); x.type = 'button'; x.textContent = FT[3];
        x.onclick = function () { save(null); location.href = only ? withTag(false) : location.href; };
        b.appendChild(x);
        var grid = parent.closest('.product-grid') || parent;
        grid.parentNode.insertBefore(b, grid);
      }
      var anyHit = items.some(function (x) { return x.hit; });
      if (items.length > 1 && (anyHit || (v && relevance))) {
        var sorted = items.slice().sort(function (a, b) {
          if (anyHit && a.hit !== b.hit) return a.hit ? -1 : 1;
          if (anyHit && a.hit) { if (a.ag !== b.ag) return a.ag ? -1 : 1; return a.price - b.price || a.i - b.i; }
          if (v && relevance && a.fr !== b.fr) return a.fr - b.fr;
          return a.i - b.i;
        });
        if (sorted.some(function (x, k) { return x !== items[k]; })) {
          var first = items[0].li, anchor = first.previousSibling;
          sorted.forEach(function (x) { parent.insertBefore(x.li, anchor ? anchor.nextSibling : parent.firstChild); anchor = x.li; });
        }
      }
      setTimeout(function () { busy = false; }, 50);
    }
    run();
    var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 150); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSearchSort); else initSearchSort();
  /* El filtro por etiqueta (Search & Discovery) solo lo usa el botón «Ver solo las de mi…»: se ocultan su desplegable (CSS) y sus pastillas */
  function hideTagPills() {
    document.querySelectorAll('facet-remove-component.facets-remove__pill').forEach(function (el) {
      if (/^(v|lc|p)-[a-z0-9-]+$/.test((el.textContent || '').trim().split(/\s+/)[0])) el.style.display = 'none';
    });
  }
  function initTagPills() {
    if (!document.querySelector('[id*="filter-p-tag"]') && !/filter\.p\.tag/.test(location.search)) return;
    hideTagPills();
    var tp; new MutationObserver(function () { clearTimeout(tp); tp = setTimeout(hideTagPills, 120); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTagPills); else initTagPills();
})();
